import { Card, CardContent } from '@/components/ui/card';
import { Abrechnungsart } from '@/domain/vertraege/features/VertragCarousel/card/Abrechnungsart';
import { Footer } from '@/domain/vertraege/features/VertragCarousel/card/Footer';
import { PreisInfo } from '@/domain/vertraege/features/VertragCarousel/card/PreisInfo';
import { VertragsInfo } from '@/domain/vertraege/features/VertragCarousel/card/VertragsInfo';
import { Vertragsvereinbarung } from '@/domain/vertraege/features/VertragCarousel/card/Vertragsvereinbarung';
import { Vertrag } from '@/domain/vertraege/shared/types/vertrag';

function VertraegeCard({ vertrag }: { vertrag: Vertrag }) {
  return (
    <Card className="w-full h-full p-5 shadow-none">
      <CardContent className="flex flex-col justify-between gap-5 p-0 h-full">
        <VertragsInfo vertrag={vertrag} />
        <hr className="w-full border-t border-dashed border-neutrals-N300" />
        <Abrechnungsart vertrag={vertrag} />
        <div className="w-full">
          <hr className="border-t border-dashed border-neutrals-N300" />
        </div>
        <Vertragsvereinbarung vertrag={vertrag} />
        <PreisInfo vertrag={vertrag} />
        <Footer vertrag={vertrag} />
      </CardContent>
    </Card>
  );
}

export default VertraegeCard;
